module.exports = __webpack_public_path__ + "img/table-icon-light.ecc4ffd9.svg";